<template>
  <div>
      <b-card
        no-body
        border-variant="msstream"
        class="marginal"
      >
        <b-card-header
          header-bg-variant="msstream"
          header-text-variant="white"
          class="text-center"
        >
          <h5 class="m-0">
            <b-row class="align-items-center justify-content-center">
            <b-icon icon="images"></b-icon>&nbsp;
              {{$ml.get('picturestitle')}}
            &nbsp;<b-badge>{{pictures.length}}</b-badge>
            </b-row>
          </h5>
        </b-card-header>
        <b-card-body>
            <div class="picture-grid picture-grid-size">
                <div class="picture-item bg-msstream" v-for="picture in pictures" v-bind:key="picture.uuid">
                    <b-img :src="picture.url" fluid :title="picture.name" class="picture-item-img"></b-img>
                    <b-button style="position:absolute; top: 0px; right:0px; z-index:80;" variant="redsmall" @click="currentPicture = picture; showModal('confirmDeletePicture');">
                        <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                    </b-button>
                </div>
            </div>
            <b-row class="align-items-center justify-content-around marginaltop">
                <b-col cols="auto">
                <input
                    type="file"
                    accept="image/*"
                    @change="selectandUploadPicture($event)"
                    id="file-input-picture"
                    class="inputfile"
                    size="sm"
                  />
                  <label
                    class="pointerOrange"
                    style="text-align: center; line-height: normal"
                    for="file-input-picture"
                  >
                    <font-awesome-icon icon="image" />&nbsp;
                    <span>
                      <span> {{$ml.get("addapicture")}} </span>
                    </span>
                  </label>
                </b-col>
            </b-row>
        </b-card-body>
      </b-card>





    <b-modal ref="successNewPicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('picture')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('pictureuploadsuccess')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('successNewPicture');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorNewPicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('picture')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('pictureuploaderror')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorNewPicture');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="confirmDeletePicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('picture')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('picturedeleteconfirm')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="msstreamblue" @click="hideModal('confirmDeletePicture');deletePicture(currentPicture)">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
          {{$ml.get('delete')}}
        </b-btn>
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('confirmDeletePicture');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

    <b-modal ref="errorDeletePicture" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          {{$ml.get('picture')}}
        </h4>
      </div>
      <p style="line-height:normal; text-align:center" v-html="$ml.get('picturedeleteerror')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-3 col-5" variant="quanteeclg" @click="hideModal('errorDeletePicture');">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('close')}}
        </b-btn>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import { BASE_URL } from "@/services/base-url";
import PictureService from "@/services/picture.service";
let pictureService = new PictureService();
export default {
  name: "PicturePage",
  components: {

  },
  data: function () {
    return {
      clientView:
        this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      pictures: [],
      currentPicture: null,
      pictureFile: null
    };
  },
  mounted() {
   this.getPictures()
  },
  computed: {
   
  },
  methods: {
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    selectandUploadPicture(event) {
        this.pictureFile = event.target.files[0];
        this.postPicture();
    },
    getPictures() {
        pictureService.getPictures({client: this.clientView, pagesize: 1000, sort: JSON.stringify({createdAt: -1})}, this.$auth.token())
        .then((response) => {
            this.pictures = response._embedded;
        }).catch(err => {
            console.log(err);
        })
    },
    postPicture() {
        pictureService.postPicture(this.pictureFile, this.clientView, this.$auth.token())
        .then((response) => {
            this.pictures.unshift(response);
        }).catch(err => {
            this.showModal("errorDeletePicture")
            console.log(err);
        })
    },
    deletePicture(picture) {
        pictureService.deletePicture(picture.uuid, this.$auth.token())
        .then((response) => {
            this.pictures.splice(this.pictures.findIndex(x => x.uuid === picture.uuid), 1);
        }).catch(err => {
            this.showModal("errorDeletePicture");
        })
    }

  },
};
</script>
<style scoped lang="scss">

.picture-grid {
    display: grid;
    grid-gap: 10px;
    align-items: center;
    justify-content: center;
}

.picture-item {
     grid-column: span 1;
     position: relative;
     padding-top: 56.25%;
     width:100%;
     transition: .15s all ease-in-out;
     &:hover {
        transform: scale(1.03)
    }
     
}

.picture-item-img {
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: contain;width: 100%;
    height: 100%;
    
}

.picture-grid-size {
    grid-template-columns: repeat(3, 1fr);
}

@media all and (min-width: 768px) {
    .picture-grid-size {
        grid-template-columns: repeat(6, 1fr);
    }
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

</style>